import { render, staticRenderFns } from "./CapacityLimit.vue?vue&type=template&id=1359b989"
import script from "./CapacityLimit.vue?vue&type=script&lang=js"
export * from "./CapacityLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports